import { ObservationType } from '@interfaces-clean/observations.interface';
import ControlsReviewLogsApi from '@apis/bff-api/central-monitoring/controls-review-log';
import SiteReviewLogsApi from '@apis/bff-api/central-monitoring/site-review-log';
import StudyReviewLogsApi from '@apis/bff-api/central-monitoring/study-review-log';

export function useAssociatedReviewLogs(
    type: ObservationType,
    studyRef: string | null,
    observationId: string | undefined,
) {
    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
    /* eslint-disable @eslint-react/rules-of-hooks */
    if (type === ObservationType.Controls) {
        return ControlsReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    if (type === ObservationType.Study) {
        return StudyReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    if (type === ObservationType.Site) {
        return SiteReviewLogsApi.useLookupReviewLogsForObservation(studyRef || '', observationId || '', type);
    }
    /* eslint-enable @eslint-react/rules-of-hooks */
    return { data: null, isLoading: false };
}
